// Group only the explicit installment suffix used by the source catalog.
// Every choice still points to its original offer and term, including TAC IDs.
export function paymentVariant(offer) {
  const title = String(offer.title || "").trim()
  const match = title.match(/^(.+),\s*([1-9]\d*)\s+Raten?$/i)
  if (match && Number.isSafeInteger(Number(match[2]))) return { title: match[1].trim(), count: Number(match[2]), label: match[2] + (Number(match[2]) === 1 ? " Rate" : " Raten") }
  return { title, count: /\braten?\b/i.test(title) ? null : 0, label: /\braten?\b/i.test(title) ? title : "Einmalzahlung" }
}

export function groupOffers(offers) {
  const buckets = new Map()
  offers.filter((offer) => !offer.blocked).forEach((offer) => {
    const variant = paymentVariant(offer)
    const key = JSON.stringify([variant.title, !!offer.flex, !!offer.seasonal])
    if (!buckets.has(key)) buckets.set(key, [])
    buckets.get(key).push({ offer, ...variant })
  })
  return Array.from(buckets.entries()).flatMap(([key, rows]) => {
    // Ambiguous duplicates stay individually selectable instead of being merged.
    if (new Set(rows.map((row) => row.count)).size !== rows.length || rows.some((row) => row.count === null)) {
      return rows.map((row) => ({ id: row.offer.id, title: row.offer.title, offers: [row.offer] }))
    }
    return [{ id: key, title: rows[0].title, offers: rows.sort((a, b) => a.count - b.count).map((row) => row.offer) }]
  })
}

export function durationKey(term) {
  return term ? JSON.stringify([term.years || 0, term.months || 0, term.days || 0]) : ""
}

export function familyTerms(family) {
  const terms = new Map()
  if (family) family.offers.forEach((offer) => offer.terms.forEach((term) => {
    const id = durationKey(term)
    if (!terms.has(id)) terms.set(id, { id, label: term.label })
  }))
  return Array.from(terms.values())
}

export function familyVariants(family, length) {
  return family ? family.offers.flatMap((offer) => offer.terms.filter((term) => durationKey(term) === length).map((term) => ({ offer, term, ...paymentVariant(offer) }))) : []
}
